module.exports = __webpack_public_path__ + "img/叶坪中国共产党苏维埃区域中央局旧址.4e8c49a4.png";